// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1VhIK","title":"card_title__mxHif","inActive":"card_inActive__1a5VY"};